"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Googleplus;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Googleplus(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "GooglePlus"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "googleplus"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35,75a25,25,0,0,1,0-50,23.881,23.881,0,0,1,16.75,6.55l-6.775,6.525a14.026,14.026,0,0,0-9.95-3.85,15.8,15.8,0,0,0,0,31.6c9.9,0,13.6-7.125,14.2-10.775H35v-8.6H58.6A20.316,20.316,0,0,1,59,50.6C59,64.875,49.425,75,35,75Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "90 54.55 82.75 54.55 82.75 61.8 75.45 61.8 75.45 54.55 68.2 54.55 68.2 47.25 75.45 47.25 75.45 40 82.75 40 82.75 47.25 90 47.25 90 54.55"
  }))));
}